import { useEffect } from "react";
import { Button } from "@cloudscape-design/components";
import "@cloudscape-design/global-styles/index.css";
import { isAndroidDevice, isIosDevice } from "../../utils/browserUtils";
import { APPLE_APP_STORE_URL, GOOGLE_PLAY_STORE_URL } from "../../utils/constants";
import "./AppRedirect.css";

/**
 * One QR -> one URL (/get) landing that routes a visitor to the right AWS Card Clash store listing:
 * iOS -> App Store, Android -> Google Play. Desktop / unknown devices can't be auto-routed, so they
 * see both store buttons rather than a dead redirect (e.g. a laptop scanning the printed QR).
 *
 * The redirect uses window.location.replace so the store page doesn't land in history (the back
 * button returns the visitor to wherever they scanned from, not this bounce page).
 */
export const AppRedirect = () => {
  useEffect(() => {
    if (isIosDevice()) {
      window.location.replace(APPLE_APP_STORE_URL);
    } else if (isAndroidDevice()) {
      window.location.replace(GOOGLE_PLAY_STORE_URL);
    }
    // Desktop / unknown: no auto-redirect — the fallback below shows both stores.
  }, []);

  return (
    <div className="app-redirect--wrapper">
      <div className="app-redirect--content">
        <h1>Get AWS Card Clash</h1>
        <p>Download the app for your device:</p>
        <div className="app-redirect--buttons">
          <Button href={APPLE_APP_STORE_URL} variant="primary" target="_blank">
            Download on the App Store
          </Button>
          <Button href={GOOGLE_PLAY_STORE_URL} variant="primary" target="_blank">
            Get it on Google Play
          </Button>
        </div>
      </div>
    </div>
  );
};
